import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1136d672")

_pushScopeId("data-v-1136d672")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, "个", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_3 = { class: "flex-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_a_form_item, {
      label: "开通坐席",
      name: _ctx.name,
      rules: [{ required: _ctx.required, message: '请输入要开通的坐席数' }],
      style: { marginBottom: _ctx.size != 'small' ? '24px' : '0' }
    }, {
      default: _withId(() => [
        _createVNode(_component_a_input_number, {
          size: _ctx.size,
          min: _ctx.appointSeats?.length || 0,
          max: 
				_ctx.data.filter((item) => !item.disabled && !_ctx.appointSeats.some((sub) => sub == item.seat))?.length +
					(_ctx.appointSeats?.length || 0) || 0
			,
          value: _ctx.seatNum,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.seatNum = $event)),
          precision: 0,
          onChange: _ctx.changeSeatNum
        }, null, 8, ["size", "min", "max", "value", "onChange"]),
        _hoisted_1
      ]),
      _: 1
    }, 8, ["name", "rules", "style"]),
    _createVNode(_component_a_form_item, {
      label: "指定坐席",
      style: { marginBottom: _ctx.size != 'small' ? '24px' : '0' }
    }, {
      default: _withId(() => [
        _createVNode(_component_a_button, {
          size: "small",
          type: "primary",
          onClick: _ctx.openSeatModal
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.appointSeats.join(',')), 1)
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
      width: "600px",
      title: "指定坐席",
      maskClosable: false,
      onOk: _ctx.confirmSeat
    }, {
      default: _withId(() => [
        _createVNode(_component_a_table, {
          scroll: _ctx.scroll,
          "data-source": _ctx.data,
          columns: _ctx.seatColumns,
          rowSelection: _ctx.rowSelection,
          loading: _ctx.loading,
          pagination: false,
          ref: "tableElRef",
          onChange: _ctx.handleTableChange,
          "row-key": (record) => record.seat
        }, null, 8, ["scroll", "data-source", "columns", "rowSelection", "loading", "onChange", "row-key"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
})